// Base path for account settings, switched by the MY_ACCOUNT_HP_NAV flag.
export const myAccountSettingsBase = (hpNav: boolean): string =>
  hpNav ? '/buy/my-account' : '/acct/settings'

// Serialize a Next `searchParams` object into a `?a=b` string ('' when empty).
export const toQueryString = (
  params: Record<string, string | string[] | undefined>
): string => {
  const sp = new URLSearchParams()
  for (const [key, value] of Object.entries(params)) {
    if (Array.isArray(value)) {
      value.forEach((v) => sp.append(key, v))
    } else if (value !== undefined) {
      sp.set(key, value)
    }
  }
  const serialized = sp.toString()
  return serialized ? `?${serialized}` : ''
}
